import { Box, Typography } from '@mui/material';

interface SectionTitleProps {
    title: string;
    withInfo?: boolean;
}

export const SectionTitle = ({ title, withInfo = false }: SectionTitleProps) => {
    return (
        <Box sx={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
            <Typography style={{
                textAlign: 'left',
            }}
                fontFamily={"Lemon milk pro"}
                fontWeight={600}
                fontSize={{
                    xs: 18,
                    sm: 20,
                    md: 24,
                }}>
                {title}
            </Typography>
            {withInfo && <i className="fi fi-br-info" style={{ fontSize: 14, color: '#FFF' }} />}
        </Box>
    );
};
